import React from 'react';

interface SettingsPanelProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

export const SettingsPanel: React.FC<SettingsPanelProps> = ({
  title,
  description,
  children,
  className = '',
}) => (
  <div className={`kx-settings-panel ${className}`.trim()}>
    <header className="kx-settings-panel__header">
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </header>
    <div className="kx-settings-panel__body">{children}</div>
  </div>
);

export default SettingsPanel;
